import { InsuranceStatus } from 'Constants/insuranceStatus.constants';
import {
  hasCostViewPermission,
  hasPolicyDownloadPermission,
} from '../helpers/insurance.helpers';
import { OrganizationPillarTypes } from '../insurance.constants';
import {
  InsuranceOverviewDto,
  PolicyOverviewDto,
} from '../types/insurance.dto.types';
import { InsuranceOverview } from '../types/insurance.types';
import { StatusCwp } from '../types/insurance.types.cwp';

export function mapToInsuranceOverview(
  dtoList: Array<InsuranceOverviewDto>,
): Array<InsuranceOverview> {
  return dtoList.map((dto) => ({
    insuranceStatus: dto.insuranceStatus,
    status: dto.status,
    insuranceType: dto.product.insuranceType || '',
    productName: dto.product.productName,
    policyNumber: dto.contractNumber,
    riskList: dto.riskList,
    coverages: (hasPolicyDownloadPermission(dto) && dto.coverages) || [],
    employerOrgNumber: dto.employerOrgNumber && dto.employerOrgNumber.number,
    monthlyCost: dto.monthlyCost,
    annualCost: dto.annualCost,
    price: dto.price,
    payer: dto.payer,
    systemName: dto.product.systemName,
    type: dto.type,
    ...(dto.payer !== null && { payer: dto.payer }),
    ...(dto.agreement !== null && {
      agreementProduct: dto.agreement.agreementProduct,
      agreementKey: dto.agreement.agreementKey,
    }),
    firstTimeValidDate: dto.firstTimeValidDate,
    permissions: {
      showCost: hasCostViewPermission(dto),
      showPolicyDownload: hasPolicyDownloadPermission(dto),
      alisCustomerRolesOnPolicy: dto.alisCustomerRolesOnPolicy,
    },
    organizationPillar: dto.product
      .organizationPillar as OrganizationPillarTypes,
    alisCustomerRolesOnPolicy: dto.alisCustomerRolesOnPolicy,
  }));
}

export const mapf2100ProductToInsuranceOverview = (
  dtoList: PolicyOverviewDto[],
): InsuranceOverview[] => {
  return dtoList.map((dto) => ({
    status: dto.status,
    agreementProduct: dto.agreementProduct,
    insuranceType: dto.insuranceProduct,
    productName: dto.description,
    policyNumber: String(dto.policyId),
    coverages: [{ insuredName: dto.insuredInfo, code: '', text: '' }],
    monthlyCost: dto.price.monthlyPrice,
    annualCost: dto.price.yearlyPrice,
    systemName: dto.systemName,
    type: dto.insuranceType,
    permissions: {
      showCost: true,
      showPolicyDownload: true,
      alisCustomerRolesOnPolicy: [],
    },
    organizationPillar: dto.organizationPillar,
    firstTimeValidDate: dto.dates.originalIssueDate,
    price: {
      monthlyPrice: dto.price.monthlyPrice,
      monthlyPricePrecise: dto.price.monthlyPrice,
      yearlyPrice: dto.price.yearlyPrice,
      yearlyPricePrecise: dto.price.yearlyPrice,
    },
    alisCustomerRolesOnPolicy: null,
    payer: null,
    riskList: [],
    insuranceStatus: mapCwpStatusToInsuranceStatus(dto.status),
  }));
};

export const mapCwpStatusToInsuranceStatus = (
  status: StatusCwp,
): InsuranceStatus => {
  switch (status) {
    case StatusCwp.ACTIVE:
      return InsuranceStatus.ACTIVE;
    case StatusCwp.CANCELLED:
      return InsuranceStatus.CANCELLED;
    case StatusCwp.UNDER_ACTIVATION:
      return InsuranceStatus.UNDER_ACTIVATION;
    case StatusCwp.UNDER_CHANGE:
    case StatusCwp.UNDER_RENEWAL:
      return InsuranceStatus.UNDER_CHANGE;
    case StatusCwp.UNDER_CANCELATION:
      return InsuranceStatus.UNDER_CANCELLATION;
    default:
      return InsuranceStatus.HIDDEN_CASE;
  }
};
